import {
  authLoginRoute,
  authLoginShopRoute,
} from "@/modules/auth/modules/login/routes";
import {
  authForgetPassRoute,
  authForgetPassVerifyRoute,
} from "@/modules/auth/modules/forget-pass/routes";
import {
  authRegisterRoute,
  authRegisterConfirmRoute,
} from "@/modules/auth/modules/register/routes";
import { authOtpRoute } from "@/modules/auth/modules/otp/routes";

export const authRoutes = {
  path: "/auth",
  redirect: "/auth/login",
  component: () => import("@/modules/auth/views/auth.vue"),
  children: [
    { ...authOtpRoute },
    { ...authLoginRoute },
    { ...authRegisterRoute },
    { ...authLoginShopRoute },
    { ...authForgetPassRoute },
    { ...authForgetPassVerifyRoute },
    { ...authRegisterConfirmRoute },
  ],
};
